<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Return of the Soldier</title>
<link href="default.css" rel="stylesheet" type="text/css"/>
<p class="toch"><b>Contents</b></p>
<p class="toc"><a href="#/ch001#tahir010" id="tahir0010">Introduction</a></p>
<p class="toc"><a href="#/ch002#tahir011" id="tahir0011">Chapter I</a></p>
<p class="toc"><span href="#/ch003#tahir012" id="tahir0012" title="Link target outside of Sample">Chapter II</span></p>
<p class="toc"><span href="#/ch004#tahir013" id="tahir0013" title="Link target outside of Sample">Chapter III</span></p>
<p class="toc"><span href="#/ch005#tahir014" id="tahir0014" title="Link target outside of Sample">Chapter IV</span></p>
<p class="toc"><span href="#/ch006#tahir015" id="tahir0015" title="Link target outside of Sample">Chapter V</span></p>
<p class="toc"><span href="#/ch007#tahir016" id="tahir0016" title="Link target outside of Sample">Chapter VI</span></p>
<p class="toc"><span href="#/bio" id="bio" title="Link target outside of Sample">A Biography of Rebecca West</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?73eb5c52